"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaPlanPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const core_1 = require("@fullcalendar/core");
const daygrid_1 = __importDefault(require("@fullcalendar/daygrid"));
const interaction_1 = __importDefault(require("@fullcalendar/interaction"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const _shared_1 = require("./children/_shared");
require("./children/post-library/component");
require("./children/post-drawer/component");
require("./children/creator-wizard/component");
require("./children/ai-assistant/component");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const _routeSearch_1 = __importStar(require("@front/pages/settings/social-media-gate/_routeSearch"));
//@ts-ignore                
let rwsTemplate = T.html `<div id="social-media-plan-page">

    ${(0, fast_element_1.when)(x => x.loading && x.posts.length === 0, (0, fast_element_1.html) `<app-loader width="20" height="20"></app-loader>`)}

    <div class="cs-main">

            ${(0, fast_element_1.when)(x => x.currentPage === 'dashboard', (0, fast_element_1.html) `
            <div class="cs-dashboard">
                <section class="row pb-3 border-bottom align-items-center">
                    <div class="col-12 col-md-7 mb-3 mb-md-0">
                        <div class="text-uppercase font-weight-bold" style="font-size:0.68rem; letter-spacing:0.5px; color:var(--cs-primary);">${'socialMediaPlan.title'.t()}</div>
                        <h2 class="font-weight-800 mb-1" style="font-size:1.3rem; font-weight:800;">${'socialMediaPlan.dashboard.heading'.t()}</h2>
                        <p class="page-desc mb-0">${'socialMediaPlan.dashboard.desc'.t()}</p>
                    </div>
                    <div class="col-12 col-md-5 text-md-right">
                        <button type="button" class="btn btn-generate" @click="${x => x.onNewPost()}">
                            <i class="iconsminds-magic-wand"></i> ${'socialMediaPlan.newPost'.t()}
                        </button>
                    </div>
                </section>

                <section class="row whatStats mt-3">
                    <div class="col-sm-6 col-lg-3 mb-3">
                        <div class="card h-100 border-0 shadow-sm bg-white">
                            <div class="card-body d-flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-muted small font-weight-bold d-block">${'socialMediaPlan.stat.scheduled'.t()}</span>
                                    <span class="font-weight-bold text-dark" style="font-size: 1.5rem;">${x => x.statScheduled}</span>
                                </div>
                                <div class="rounded-circle p-2 text-primary border" style="background-color: rgba(0, 123, 255, 0.1); width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-color: rgba(0, 123, 255, 0.25);">
                                    <i class="simple-icon-calendar" style="font-size: 1.4rem;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-3 mb-3">
                        <div class="card h-100 border-0 shadow-sm bg-white">
                            <div class="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-muted small font-weight-bold d-block">${'socialMediaPlan.stat.drafts'.t()}</span>
                                    <span class="font-weight-bold text-warning" style="font-size: 1.5rem;">${x => x.statDrafts}</span>
                                </div>
                                <div class="rounded-circle p-2 text-warning border" style="background-color: rgba(255, 193, 7, 0.1); width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-color: rgba(255, 193, 7, 0.25);">
                                    <i class="iconsminds-file-edit" style="font-size: 1.4rem;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-3 mb-3">
                        <div class="card h-100 border-0 shadow-sm bg-white">
                            <div class="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-muted small font-weight-bold d-block">${'socialMediaPlan.stat.published'.t()}</span>
                                    <span class="font-weight-bold text-success" style="font-size: 1.5rem;">${x => x.statPublished}</span>
                                </div>
                                <div class="rounded-circle p-2 text-success" style="background-color: rgba(40, 167, 69, 0.1); width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
                                    <i class="simple-icon-rocket" style="font-size: 1.4rem;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-3 mb-3">
                        <div class="card h-100 border-0 shadow-sm bg-white">
                            <div class="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-muted small font-weight-bold d-block">${'socialMediaPlan.stat.total'.t()}</span>
                                    <span class="font-weight-bold text-dark" style="font-size: 1.5rem;">${x => x.posts.length}</span>
                                </div>
                                <div class="rounded-circle p-2 text-danger border" style="background-color: rgba(220, 53, 69, 0.1); width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-color: rgba(220, 53, 69, 0.25);">
                                    <i class="simple-icon-heart" style="font-size: 1.4rem;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                ${(0, fast_element_1.when)(x => x.postsNeedingReview.length > 0, (0, fast_element_1.html) `
                <section class="card border-0 shadow-sm mb-4">
                    <div class="card-header bg-white border-bottom d-flex flex-wrap align-items-center justify-content-between py-3" style="gap:10px;">
                        <div class="d-flex align-items-center" style="gap:8px;">
                            <i class="simple-icon-check text-warning" style="font-size:1.1rem;"></i>
                            <h2 class="h6 mb-0 font-weight-bold text-dark">${'socialMediaPlan.approvalQueue.title'.t()}</h2>
                            <span class="badge badge-warning">${x => x.postsNeedingReview.length}</span>
                        </div>
                        <small class="text-muted">${'socialMediaPlan.approvalQueue.desc'.t()}</small>
                    </div>
                    <div class="card-body" id="approvalQueueList">
                        ${(0, fast_element_1.repeat)(x => x.postsNeedingReview, (0, fast_element_1.html) `
                        <div class="approval-item">
                            <span class="pf-row" :innerHTML="${(p, c) => c.parent.pfBadgesHtml(p.platforms || [], 26)}"></span>
                            <div class="flex-grow-1 min-width-0 ml-1">
                                <div class="ap-title text-truncate">${p => p.title}</div>
                                <div class="ap-meta">${'socialMediaPlan.approvalQueue.proposedDate'.t()} ${(p, c) => c.parent.formatDate(p.scheduledAt)}</div>
                            </div>
                            <button type="button" class="btn btn-outline-secondary btn-sm" title="${'socialMediaPlan.approvalQueue.preview'.t()}" @click="${(p, c) => c.parent.onPreviewApprovalPost(p)}"><i class="simple-icon-eye"></i></button>
                            <button type="button" class="btn btn-outline-danger btn-sm" @click="${(p, c) => c.parent.rejectPost(p)}">${'socialMediaPlan.approvalQueue.reject'.t()}</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="${(p, c) => c.parent.approvePost(p)}"><i class="simple-icon-check mr-1"></i>${'socialMediaPlan.approvalQueue.approve'.t()}</button>
                        </div>
                        `)}
                    </div>
                </section>
                `)}

                <section class="studio-tabs-wrap mt-4 mb-3">
                    <div class="studio-tabs">
                        <button type="button" class="studio-tab ${x => x.currentView === 'posty' ? 'active' : ''}" @click="${x => x.switchView('posty')}"><i class="iconsminds-library"></i> ${'socialMediaPlan.tab.posts'.t()}</button>
                        <button type="button" class="studio-tab ${x => x.currentView === 'harmonogram' ? 'active' : ''}" @click="${x => x.switchView('harmonogram')}"><i class="simple-icon-calendar"></i> ${'socialMediaPlan.tab.calendar'.t()}</button>
                        <button type="button" class="studio-tab ${x => x.currentView === 'historia' ? 'active' : ''}" @click="${x => x.switchView('historia')}"><i class="simple-icon-clock"></i> ${'socialMediaPlan.tab.history'.t()}</button>
                    </div>
                </section>

                ${(0, fast_element_1.when)(x => x.currentView === 'harmonogram', (0, fast_element_1.html) `
                <section class="card border-0 shadow-sm mb-4">
                    <div class="card-header bg-white border-bottom d-flex flex-wrap align-items-center justify-content-between py-3" style="gap: 10px;">
                        <div class="d-flex align-items-center" style="gap: 8px;">
                            <i class="simple-icon-calendar text-primary" style="font-size: 1.1rem;"></i>
                            <h2 class="h6 mb-0 font-weight-bold text-dark">${'socialMediaPlan.tab.calendar'.t()}</h2>
                        </div>
                    </div>
                    <div class="card-body"><div id="fcCalendar"></div></div>
                </section>
                `)}

                ${(0, fast_element_1.when)(x => x.currentView === 'historia', (0, fast_element_1.html) `
                <section class="card border-0 shadow-sm mb-4" style="height: 340px;">
                    <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                        <div class="d-flex align-items-center">
                            <div class="bg-success rounded-circle" style="width: 10px; height: 10px; margin-right: 10px;"></div>
                            <h2 class="h6 mb-0 font-weight-bold text-uppercase text-dark" style="font-size: 0.8rem;">${'socialMediaPlan.tab.history'.t()}</h2>
                        </div>
                    </div>
                    <div class="card-body overflow-auto p-3" style="background-color: #f2f3f5; color: #3a3a3a; border: 1px solid #dde0e4; font-family: 'Courier New', monospace; font-size: 0.82rem; line-height: 1.6;">
                        ${(0, fast_element_1.when)(x => x.activityLog.length === 0, (0, fast_element_1.html) `<div class="text-muted small">${'socialMediaPlan.history.empty'.t()}</div>`)}
                        ${(0, fast_element_1.repeat)(x => x.activityLog, (0, fast_element_1.html) `<div class="mb-2" style="color:#1a6fa8;">${x => x}</div>`)}
                    </div>
                </section>
                `)}

                ${(0, fast_element_1.when)(x => x.currentView === 'posty', (0, fast_element_1.html) `
                <sm-post-library
                    :filteredPosts="${x => x.filteredPosts}"
                    :loading="${x => x.loading}"
                    currentFilter="${x => x.currentFilter}"
                    @filter-change="${(x, c) => x.onFilterChange(c.event)}"
                    @search="${(x, c) => x.onSearch(c.event)}"
                    @open-creator="${(x, c) => x.onOpenCreator(c.event)}"
                    @open-drawer="${(x, c) => x.onOpenDrawer(c.event)}"
                    @edit-post="${(x, c) => x.onEditPost(c.event)}"
                    @duplicate-post="${(x, c) => x.onDuplicatePost(c.event)}"
                    @delete-post="${(x, c) => x.onDeletePost(c.event)}"
                ></sm-post-library>
                `)}

                <sm-ai-assistant
                    proxy="${x => x.proxy}"
                    :posts="${x => x.posts}"
                    :statPublished="${x => x.statPublished}"
                    :statScheduled="${x => x.statScheduled}"
                    :statDrafts="${x => x.statDrafts}"
                ></sm-ai-assistant>

            </div>
            `)}

            ${(0, fast_element_1.when)(x => x.currentPage === 'channels', (0, fast_element_1.html) `
            <div class="page-pane active" data-page="channels">
                <section class="page-header pb-3 border-bottom mb-3">
                    <div>
                        <h2 class="mb-1">${'socialMediaPlan.channels.title'.t()}</h2>
                        <p class="page-desc mb-0">${'socialMediaPlan.channels.desc'.t()}</p>
                    </div>
                </section>
                <div class="cs-list">
                    <div class="empty-state">
                        <div class="es-icon"><i class="simple-icon-share-alt"></i></div>
                        <div class="es-title">${'socialMediaPlan.wip.title'.t()}</div>
                        <div class="es-desc">${'socialMediaPlan.wip.description'.t()}</div>
                    </div>
                </div>
            </div>
            `)}

            ${(0, fast_element_1.when)(x => x.currentPage === 'analytics', (0, fast_element_1.html) `
            <div class="page-pane active" data-page="analytics">
                <section class="page-header pb-3 border-bottom mb-3">
                    <div>
                        <h2 class="mb-1">${'socialMediaPlan.analytics.title'.t()}</h2>
                    </div>
                </section>
                <div class="cs-list">
                    <div class="empty-state">
                        <div class="es-icon"><i class="iconsminds-statistic"></i></div>
                        <div class="es-title">${'socialMediaPlan.wip.title'.t()}</div>
                        <div class="es-desc">${'socialMediaPlan.wip.description'.t()}</div>
                    </div>
                </div>
            </div>
            `)}

    </div>

    <sm-post-drawer
        proxy="${x => x.proxy}"
        :selectedPost="${x => x.selectedPost}"
        :drawerOpen="${x => x.drawerOpen}"
        @drawer-closed="${x => x.onCloseDrawer()}"
        @edit-post="${(x, c) => x.onEditPost(c.event)}"
        @duplicate-post="${(x, c) => x.onDuplicatePost(c.event)}"
        @delete-post="${(x, c) => x.onDeletePost(c.event)}"
        @publish-post="${(x, c) => x.onPublishPost(c.event)}"
    ></sm-post-drawer>

    <sm-creator-wizard
        proxy="${x => x.proxy}"
        :creatorOpen="${x => x.creatorOpen}"
        :editingPost="${x => x.editingPost}"
        @wizard-closed="${x => x.onCloseCreator()}"
        @post-saved="${x => x.onPostSaved()}"
    ></sm-creator-wizard>

</div>
`;
require("./styles/layout.scss");
const styles = T.css `@charset "UTF-8";
.cs-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(24, 24, 56, 0.06);
}

.btn-cs-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #5B3DF6;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.12s;
}
.btn-cs-primary:hover {
  opacity: 0.92;
}
.btn-cs-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cs-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #3A3F49;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}
.btn-cs-outline:hover {
  background: #EFF1F4;
}

.btn-cs-danger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #DC2626;
  border: 1px solid #f3c8c8;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-cs-danger:hover {
  background: #FDEAEA;
}

.btn-cs-publish {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #16A34A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-cs-publish:hover {
  opacity: 0.9;
}
.btn-cs-publish:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cs-badge {
  font-size: 0.7rem;
  font-weight: 700;
  background: #EFF1F4;
  color: #6B7180;
  border-radius: 20px;
  padding: 2px 8px;
}

.cs-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.cs-page-header h2 {
  font-size: 1.25rem;
  font-weight: 800;
  margin: 0 0 4px;
}
.cs-page-header .cs-label-primary {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5B3DF6;
  margin-bottom: 2px;
}
.cs-page-header .cs-desc {
  font-size: 0.84rem;
  color: #6B7180;
  max-width: 560px;
  margin: 0;
}

.cs-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.cs-stat-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cs-stat-card .cs-stat-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #6B7180;
}
.cs-stat-card .cs-stat-value {
  font-size: 1.6rem;
  font-weight: 800;
  color: #16181D;
}
.cs-stat-card .cs-stat-value.warn {
  color: #B45309;
}
.cs-stat-card .cs-stat-value.success {
  color: #16A34A;
}

.cs-studio-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #EFF1F4;
  margin-bottom: 16px;
}
.cs-studio-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-studio-tabs button:hover {
  color: #3A3F49;
}
.cs-studio-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}

.cs-library-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.cs-library-header .cs-library-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
}

.cs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.cs-filters .cs-search-wrap {
  position: relative;
  flex: 1 1 200px;
}
.cs-filters .cs-search-wrap i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9199A8;
  font-size: 0.8rem;
}
.cs-filters .cs-search-wrap input {
  width: 100%;
  padding: 7px 10px 7px 30px;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  font-size: 0.82rem;
}
.cs-filters .cs-filter-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-filters .cs-filter-btns button {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 999px;
  padding: 5px 14px;
  font-size: 0.74rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.cs-filters .cs-filter-btns button:hover {
  background: #EFF1F4;
}
.cs-filters .cs-filter-btns button.active {
  background: #F1EEFF;
  color: #5B3DF6;
  border-color: #E1D9FF;
}

.cs-posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
}

.cs-post-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.12s;
}
.cs-post-card:hover {
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
  border-color: #C4C9D2;
  transform: translateY(-2px);
}
.cs-post-card .cs-post-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-post-card .cs-post-title {
  font-weight: 700;
  font-size: 0.88rem;
  margin-bottom: 4px;
  color: #16181D;
}
.cs-post-card .cs-post-excerpt {
  font-size: 0.76rem;
  color: #6B7180;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 32px;
  margin-bottom: 10px;
}
.cs-post-card .cs-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-post-card .cs-post-date {
  font-size: 0.7rem;
  color: #9199A8;
}
.cs-post-card .cs-post-actions {
  display: flex;
  gap: 4px;
}
.cs-post-card .cs-post-actions button {
  background: none;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 3px 7px;
  font-size: 0.7rem;
  cursor: pointer;
  color: #6B7180;
  transition: background 0.1s;
}
.cs-post-card .cs-post-actions button:hover {
  background: #EFF1F4;
}
.cs-post-card .cs-post-actions button.danger {
  color: #DC2626;
  border-color: #f3c8c8;
}
.cs-post-card .cs-post-actions button.danger:hover {
  background: #FDEAEA;
}

.cs-platform-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}

.cs-platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 6px 6px 0;
}
.cs-platform-chip:hover {
  border-color: #C4C9D2;
}
.cs-platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}

.cs-empty {
  text-align: center;
  padding: 48px 20px;
}
.cs-empty .cs-empty-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 1.4rem;
}
.cs-empty strong {
  display: block;
  font-size: 1rem;
  color: #22252C;
  margin-bottom: 6px;
}
.cs-empty p {
  font-size: 0.82rem;
  color: #6B7180;
  max-width: 360px;
  margin: 0 auto 14px;
}

.cs-ai-assistant {
  background: linear-gradient(135deg, #F1EEFF 0%, #fff 100%);
  border-color: #E1D9FF;
}
.cs-ai-assistant .cs-ai-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}
.cs-ai-assistant .cs-ai-header .cs-ai-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
}
.cs-ai-assistant .cs-ai-header strong {
  font-size: 0.94rem;
  font-weight: 700;
}
.cs-ai-assistant .cs-ai-header p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 2px 0 0;
}
.cs-ai-assistant .cs-ai-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 12px;
}
.cs-ai-assistant .cs-ai-presets button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 0.76rem;
  font-weight: 600;
  color: #5B3DF6;
  cursor: pointer;
  transition: background 0.12s;
}
.cs-ai-assistant .cs-ai-presets button:hover {
  background: #F1EEFF;
}
.cs-ai-assistant .cs-ai-input-row {
  display: flex;
  gap: 8px;
}
.cs-ai-assistant .cs-ai-input-row input {
  flex: 1;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.84rem;
}
.cs-ai-assistant .cs-ai-response {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  margin-top: 14px;
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header span {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  gap: 7px;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-text {
  padding: 14px;
  font-size: 0.84rem;
  white-space: pre-wrap;
  color: #22252C;
  min-height: 40px;
}

.cs-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 16, 24, 0.4);
  z-index: 200;
}

.cs-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 440px;
  height: 100vh;
  background: #fff;
  box-shadow: var(--cs-shadow-lg);
  z-index: 210;
  display: flex;
  flex-direction: column;
}
@media (max-width: 500px) {
  .cs-drawer {
    width: 100vw;
  }
}
.cs-drawer .cs-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-header h5 {
  margin: 0 0 4px;
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-drawer .cs-drawer-header button {
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-drawer .cs-drawer-tabs {
  display: flex;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-tabs button {
  flex: 1;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-drawer .cs-drawer-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}
.cs-drawer .cs-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 16px;
}
.cs-drawer .cs-drawer-meta {
  background: #EFF1F4;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.cs-drawer .cs-drawer-meta div {
  text-align: center;
}
.cs-drawer .cs-drawer-meta span {
  display: block;
  font-size: 0.68rem;
  color: #6B7180;
  margin-bottom: 2px;
}
.cs-drawer .cs-drawer-meta strong {
  font-size: 0.78rem;
}
.cs-drawer .cs-platform-preview {
  margin-bottom: 12px;
}
.cs-drawer .cs-pf-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.cs-drawer .cs-pf-text {
  font-size: 0.82rem;
  color: #3A3F49;
  white-space: pre-wrap;
  padding: 8px;
  background: #EFF1F4;
  border-radius: 8px;
}
.cs-drawer .cs-pf-hashtags {
  font-size: 0.76rem;
  color: #2563EB;
  margin-top: 4px;
}
.cs-drawer .cs-best-time {
  display: flex;
  gap: 8px;
  font-size: 0.82rem;
  margin-bottom: 8px;
}
.cs-drawer .cs-drawer-footer {
  border-top: 1px solid #EFF1F4;
  padding: 10px 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cs-creator-overlay {
  position: fixed;
  inset: 0;
  background: #F6F6FA;
  z-index: 300;
  display: flex;
  flex-direction: column;
}

.cs-creator-topbar {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.cs-creator-topbar .cs-creator-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cs-creator-topbar .cs-creator-title .cs-creator-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
.cs-creator-topbar .cs-creator-title strong {
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-creator-topbar .cs-creator-title small {
  display: block;
  font-size: 0.72rem;
  color: #9199A8;
}
.cs-creator-topbar .cs-creator-steps {
  display: flex;
  align-items: center;
}

.cs-creator-body {
  flex: 1;
  overflow-y: auto;
  padding: 28px 20px 40px;
}

.cs-creator-step {
  max-width: 1100px;
  margin: 0 auto;
}

.cs-creator-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-creator-footer .cs-creator-footer-right {
  display: flex;
  gap: 10px;
}

.cs-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
}
.cs-field-label.tip {
  color: #5B3DF6;
}

.cs-generate-gate {
  text-align: center;
  padding: 48px 20px;
}
.cs-generate-gate i {
  font-size: 2.4rem;
  color: #5B3DF6;
}
.cs-generate-gate h5 {
  font-weight: 700;
  margin: 14px 0 6px;
}
.cs-generate-gate p {
  font-size: 0.82rem;
  color: #6B7180;
  margin-bottom: 18px;
}

.cs-preview-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-bottom: 16px;
}
.cs-preview-tabs button {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  background: #fff;
  padding: 7px 13px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: all 0.12s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cs-preview-tabs button.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
}

.cs-platform-editor {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: flex-start;
}
@media (max-width: 768px) {
  .cs-platform-editor {
    grid-template-columns: 1fr;
  }
}

.cs-platform-editor-form label {
  display: block;
  margin-bottom: 6px;
}
.cs-platform-editor-form textarea {
  width: 100%;
}

.cs-image-gen-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.cs-generated-image {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
}
.cs-generated-image img {
  display: block;
  width: 100%;
  max-height: 340px;
  object-fit: cover;
}

.cs-goal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.cs-goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.cs-goal-card:hover {
  border-color: #C4C9D2;
  background: rgba(91, 61, 246, 0.04);
}
.cs-goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.cs-goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.cs-goal-card span {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 6px;
}

.cs-tip-card {
  background: #F1EEFF !important;
  border-color: #E1D9FF !important;
}
.cs-tip-card p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 0;
}

.cs-action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-top: 8px;
}

.cs-recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.cs-recap-row:last-child {
  border-bottom: none;
}
.cs-recap-row span {
  color: #6B7180;
  white-space: nowrap;
  flex-shrink: 0;
  padding-right: 8px;
}
.cs-recap-row strong {
  text-align: right;
  word-break: break-word;
}

.cs-calendar-section, .cs-history-section {
  min-height: 300px;
}

.cs-log-line {
  font-size: 0.8rem;
  font-family: "Courier New", monospace;
  padding: 2px 0;
  color: #1a6fa8;
}

.btn-generate app-loader, .btn-cs-primary app-loader, .btn-cs-outline app-loader, .btn-cs-publish app-loader, .btn-cs-danger app-loader {
  position: static !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  width: 14px !important;
  height: 14px !important;
}

.pc-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
}

.pc-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pc-hint {
  font-size: 0.72rem;
  color: #9199A8;
  margin-top: 4px;
}

.btn-generate {
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  border: none;
  color: #fff;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(91, 61, 246, 0.28);
  transition: transform 0.12s, box-shadow 0.12s;
}
.btn-generate:hover {
  color: #fff;
  opacity: 0.96;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(91, 61, 246, 0.34);
}
.btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 8px 8px 0;
}
.platform-chip:hover {
  border-color: #C4C9D2;
}
.platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.platform-chip .chip-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #22252C;
}

.goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.goal-card:hover {
  border-color: #C4C9D2;
}
.goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.goal-card .goal-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 4px;
}

.native-preview {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.09);
  background: #fff;
  box-shadow: 0 8px 32px rgba(24, 24, 56, 0.13), 0 1px 3px rgba(0, 0, 0, 0.06);
  max-width: 320px;
}

.np-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.np-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5B3DF6 0%, #8B6FF8 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.72rem;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(91, 61, 246, 0.35);
}

.np-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}

.np-handle {
  font-size: 0.68rem;
  color: #9199A8;
  line-height: 1.2;
}

.np-more {
  margin-left: auto;
  color: #C4C9D2;
  font-size: 1.1rem;
  line-height: 1;
}

.np-media {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  color: #C4C9D2;
  font-size: 0.72rem;
  min-height: 180px;
  background: repeating-linear-gradient(135deg, #f5f6f8 0px, #f5f6f8 10px, #eceef1 10px, #eceef1 20px);
}
.np-media i {
  font-size: 2rem;
  opacity: 0.5;
}
.np-media img {
  width: 100%;
  display: block;
  max-height: 260px;
  object-fit: cover;
}

.np-caption {
  padding: 12px 14px 6px;
  font-size: 0.82rem;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  color: #1a1d23;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.np-hashtags {
  padding: 0 14px 12px;
  font-size: 0.76rem;
  color: #4267b2;
  font-weight: 500;
  line-height: 1.5;
}

.np-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  color: #6B7180;
}
.np-footer span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: color 0.12s;
}
.np-footer span:hover {
  color: #5B3DF6;
}

.pv-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 2px solid #EFF1F4;
}

.pv-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 6px 14px 6px 8px;
  cursor: pointer;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  transition: all 0.15s;
}
.pv-tab:hover {
  border-color: #C4C9D2;
  background: #EFF1F4;
}
.pv-tab.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
  box-shadow: 0 0 0 3px rgba(91, 61, 246, 0.1);
}
.pv-tab .pv-tab-warn {
  color: #DC2626;
  margin-left: 2px;
}

.pv-pane {
  display: none;
}

.pv-pane.active {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 28px;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .pv-pane.active {
    grid-template-columns: 1fr;
  }
}

.pv-preview-col {
  position: sticky;
  top: 16px;
}

.pv-editor {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.pv-editor .pv-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.pv-editor .pv-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pv-editor .pv-field-header label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #3A3F49;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.pv-editor .pv-field-header .pv-field-meta {
  font-size: 0.7rem;
  color: #9199A8;
}
.pv-editor textarea {
  font-size: 0.88rem;
  line-height: 1.7;
  color: #16181D;
  width: 100%;
  resize: vertical;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  min-height: 130px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor textarea:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor input[type=text] {
  font-size: 0.84rem;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor input[type=text]:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor .pv-hashtag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 2px;
}
.pv-editor .pv-hashtag-chips span {
  display: inline-block;
  background: #EAF1FE;
  color: #2563EB;
  font-size: 0.73rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
}

.pv-counter {
  font-size: 0.72rem;
  color: #9199A8;
  text-align: right;
}
.pv-counter.over {
  color: #DC2626;
  font-weight: 700;
}

.pv-limit-track {
  height: 4px;
  border-radius: 4px;
  background: #EFF1F4;
  overflow: hidden;
}

.pv-limit-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s, background 0.2s;
  background: #16A34A;
}
.pv-limit-fill.warn {
  background: #B45309;
}
.pv-limit-fill.over {
  background: #DC2626;
}

.pv-insight-card {
  background: linear-gradient(135deg, #F1EEFF, #fff);
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 12px 14px;
}

.pv-insight-title {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 800;
  color: #5B3DF6;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.gen-img-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.gen-img-preview {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
  background: #EFF1F4;
  position: relative;
  line-height: 0;
}
.gen-img-preview img {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: cover;
}
.gen-img-preview .gen-img-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 0.64rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 9px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  backdrop-filter: blur(4px);
}

.engagement-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 10px;
}

.engagement-Wysoki {
  background: #E9F9EF;
  color: #16A34A;
}

.engagement-Średni {
  background: #FDF3E3;
  color: #B45309;
}

.engagement-Niski {
  background: #FDEAEA;
  color: #DC2626;
}

.schedule-choice {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.schedule-choice:hover {
  border-color: #C4C9D2;
}
.schedule-choice.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.schedule-choice i {
  font-size: 1.25rem;
  color: #5B3DF6;
  display: block;
}
.schedule-choice .sc-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #22252C;
  margin: 6px 0 2px;
}
.schedule-choice .sc-desc {
  font-size: 0.7rem;
  color: #9199A8;
}

.recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.recap-row:last-child {
  border-bottom: none;
}
.recap-row span {
  color: #6B7180;
}
.recap-row strong {
  text-align: right;
}

:root {
  --cs-shadow-lg: 0 20px 48px rgba(24,24,56,.16);
}

.pf-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
  border-radius: 50%;
  line-height: 1;
}
.pf-badge.pf-facebook {
  background: #1877F2;
}
.pf-badge.pf-instagram {
  background: linear-gradient(135deg, #f9ce34, #ee2a7b, #6228d7);
}
.pf-badge.pf-x {
  background: #000;
}
.pf-badge.pf-linkedin {
  background: #0A66C2;
}
.pf-badge.pf-tiktok {
  background: linear-gradient(135deg, #25F4EE, #111 45%, #FE2C55);
}
.pf-badge.pf-youtube {
  background: #FF0000;
}
.pf-badge.pf-threads {
  background: #000;
}
.pf-badge.pf-pinterest {
  background: #E60023;
}

.pf-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.68rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 4px 11px;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
.status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}
.status-badge.status-draft {
  background: #EFF1F4;
  color: #6B7180;
}
.status-badge.status-scheduled {
  background: #EAF1FE;
  color: #2563EB;
}
.status-badge.status-needs_review {
  background: #FDF3E3;
  color: #B45309;
}
.status-badge.status-published {
  background: #E9F9EF;
  color: #16A34A;
}
.status-badge.status-failed {
  background: #FDEAEA;
  color: #DC2626;
}

.cs-step {
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.45;
}
.cs-step.active, .cs-step.done {
  opacity: 1;
}

.cs-step-num {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #EFF1F4;
  color: #6B7180;
  font-size: 0.78rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
}
.active .cs-step-num {
  background: #5B3DF6;
  color: #fff;
}
.done .cs-step-num {
  background: #16A34A;
  color: #fff;
}

.cs-step-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #3A3F49;
  white-space: nowrap;
}

.cs-step-sep {
  width: 34px;
  height: 2px;
  background: #E2E5EA;
  margin: 0 10px;
}

.cs-platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 6px 6px 0;
}
.cs-platform-chip:hover {
  border-color: #C4C9D2;
}
.cs-platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}

.cs-goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.cs-goal-card:hover {
  border-color: #C4C9D2;
}
.cs-goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.cs-goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
}
.cs-goal-card span {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 4px;
}

.cs-action-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 10px;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s;
  height: 100%;
}
.cs-action-card:hover {
  border-color: #C4C9D2;
}
.cs-action-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.cs-action-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
}

.cs-action-title {
  font-size: 0.8rem;
  font-weight: 700;
  margin: 6px 0 2px;
}

.cs-action-desc {
  font-size: 0.68rem;
  color: #9199A8;
}

.cs-recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.cs-recap-row:last-child {
  border-bottom: none;
}
.cs-recap-row span {
  color: #6B7180;
  white-space: nowrap;
}
.cs-recap-row strong {
  text-align: right;
}

#social-media-plan-page {
  --cs-primary: #5B3DF6;
  --cs-primary-dark: #4527D6;
  --cs-primary-soft: #F1EEFF;
  --cs-primary-soft-border: #E1D9FF;
  --cs-ink-900: #16181D;
  --cs-ink-800: #22252C;
  --cs-ink-700: #3A3F49;
  --cs-ink-500: #6B7180;
  --cs-ink-400: #9199A8;
  --cs-ink-300: #C4C9D2;
  --cs-ink-200: #E2E5EA;
  --cs-ink-100: #EFF1F4;
  --cs-bg: #F6F6FA;
  --cs-success: #16A34A;
  --cs-success-soft: #E9F9EF;
  --cs-warning: #B45309;
  --cs-warning-soft: #FDF3E3;
  --cs-danger: #DC2626;
  --cs-danger-soft: #FDEAEA;
  --cs-info: #2563EB;
  --cs-info-soft: #EAF1FE;
  --cs-radius-sm: 8px;
  --cs-radius-md: 12px;
  --cs-radius-pill: 999px;
  --cs-shadow-xs: 0 1px 2px rgba(20, 20, 43, 0.05);
  --cs-shadow-sm: 0 2px 8px rgba(24, 24, 56, 0.06);
  --cs-shadow-md: 0 10px 28px rgba(24, 24, 56, 0.10);
  --cs-shadow-lg: 0 20px 48px rgba(24, 24, 56, 0.16);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
#social-media-plan-page .cs-main {
  padding: 0;
  overflow-y: auto;
}
#social-media-plan-page h1, #social-media-plan-page h2, #social-media-plan-page h3, #social-media-plan-page h4, #social-media-plan-page h5, #social-media-plan-page h6 {
  letter-spacing: -0.01em;
  color: var(--cs-ink-900);
}
#social-media-plan-page .page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
#social-media-plan-page .page-header h2 {
  font-size: 1.2rem;
  font-weight: 800;
}
#social-media-plan-page .page-desc {
  font-size: 0.84rem;
  color: var(--cs-ink-500);
  max-width: 640px;
}
#social-media-plan-page .btn {
  border-radius: var(--cs-radius-sm);
  font-weight: 600;
}
#social-media-plan-page .btn-generate {
  background: linear-gradient(135deg, var(--cs-primary), #8B6FF8);
  border: none;
  color: #fff;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: var(--cs-radius-sm);
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(91, 61, 246, 0.28);
  transition: transform 0.12s, box-shadow 0.12s;
  cursor: pointer;
}
#social-media-plan-page .btn-generate:hover {
  color: #fff;
  opacity: 0.96;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(91, 61, 246, 0.34);
}
#social-media-plan-page .btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
#social-media-plan-page .studio-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--cs-ink-100);
}
#social-media-plan-page .studio-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--cs-ink-400);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}
#social-media-plan-page .studio-tab:hover {
  color: var(--cs-ink-700);
}
#social-media-plan-page .studio-tab.active {
  color: var(--cs-primary);
  border-bottom-color: var(--cs-primary);
}
#social-media-plan-page .empty-state {
  text-align: center;
  padding: 48px 20px;
}
#social-media-plan-page .empty-state .es-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--cs-primary-soft);
  color: var(--cs-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  font-size: 1.5rem;
}
#social-media-plan-page .empty-state .es-title {
  font-weight: 700;
  color: var(--cs-ink-800);
  margin-bottom: 4px;
}
#social-media-plan-page .empty-state .es-desc {
  font-size: 0.82rem;
  color: var(--cs-ink-500);
  max-width: 360px;
  margin: 0 auto 16px;
}
#social-media-plan-page .cs-list {
  border: 1px solid var(--cs-ink-100);
  border-radius: var(--cs-radius-md);
  overflow: hidden;
  background: #fff;
  box-shadow: var(--cs-shadow-xs);
}
#social-media-plan-page .post-card {
  border: 1px solid var(--cs-ink-100);
  border-radius: var(--cs-radius-md);
  background: #fff;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
}
#social-media-plan-page .post-card:hover {
  box-shadow: var(--cs-shadow-md);
  border-color: var(--cs-ink-200);
  transform: translateY(-2px);
}
#social-media-plan-page .post-card-excerpt {
  font-size: 0.78rem;
  color: var(--cs-ink-500);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 54px;
}
#social-media-plan-page .post-card-actions .btn {
  padding: 4px 8px;
  font-size: 0.72rem;
  border-radius: var(--cs-radius-sm);
}
#social-media-plan-page .btn-outline-primary {
  color: var(--cs-primary) !important;
  border-color: var(--cs-primary-soft-border) !important;
}
#social-media-plan-page .btn-outline-primary:hover {
  background: var(--cs-primary) !important;
  border-color: var(--cs-primary) !important;
  color: #fff !important;
}
#social-media-plan-page .btn-outline-secondary {
  color: var(--cs-ink-500) !important;
  border-color: var(--cs-ink-200) !important;
}
#social-media-plan-page .btn-outline-secondary:hover {
  background: var(--cs-ink-100) !important;
  color: var(--cs-ink-800) !important;
}
#social-media-plan-page .btn-outline-danger {
  color: var(--cs-danger) !important;
  border-color: #f3c8c8 !important;
}
#social-media-plan-page .btn-outline-danger:hover {
  background: var(--cs-danger-soft) !important;
}
#social-media-plan-page .btn-primary {
  background: var(--cs-primary) !important;
  border-color: var(--cs-primary) !important;
}
#social-media-plan-page .filter-btn.active {
  font-weight: bold;
}
#social-media-plan-page #approvalQueueList {
  padding: 0;
}
#social-media-plan-page .approval-item {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--cs-ink-100);
  border-radius: var(--cs-radius-sm);
  margin-bottom: 8px;
  background: #fff;
  flex-wrap: nowrap;
}
#social-media-plan-page .approval-item:last-child {
  margin-bottom: 0;
}
#social-media-plan-page .approval-item .pf-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
#social-media-plan-page .approval-item .ap-title {
  font-weight: 700;
  font-size: 0.84rem;
  color: var(--cs-ink-800);
}
#social-media-plan-page .approval-item .ap-meta {
  font-size: 0.72rem;
  color: var(--cs-ink-400);
  margin-top: 2px;
}
#social-media-plan-page .approval-item .flex-grow-1 {
  min-width: 0;
}`;
const shadowOptions = { "mode": "open" };
let SocialMediaPlanPage = class SocialMediaPlanPage extends client_1.RWSViewComponent {
    constructor(popupService, wsService, routeSearchService) {
        super();
        this.popupService = popupService;
        this.wsService = wsService;
        this.routeSearchService = routeSearchService;
        this.currentPage = 'dashboard';
        this.currentView = 'posty';
        this.loading = false;
        this.posts = [];
        this.filteredPosts = [];
        this.currentFilter = 'all';
        this.selectedPost = null;
        this.drawerOpen = false;
        this.creatorOpen = false;
        this.editingPost = null;
        this.statScheduled = 0;
        this.statDrafts = 0;
        this.statPublished = 0;
        this.activityLog = [];
        this.postsNeedingReview = [];
        this.uploadProgress = new Map();
        this.proxy = false;
        this.statusListenerCallBacks = [];
        this.calendar = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadPosts();
        if (this.wsService.isActive()) {
            this.statusListenerCallBacks.push(this.wsService.listenForMessage('status_update', (response) => {
                console.log(response);
            }));
        }
    }
    async loadPosts() {
        this.loading = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-post.list', undefined, undefined, 'GET')
                : await this.apiService.back.get('social-media-post.list');
            if (resp === null || resp === void 0 ? void 0 : resp.success) {
                this.posts = resp.data || [];
                this.postsNeedingReview = this.posts.filter(p => p.status === 'needs_review');
                this.applyFilter();
                this.computeStats();
                this.logActivity(`Panel załadowany. ${this.posts.length} postów w bibliotece.`);
            }
        }
        catch (_a) {
            this.notifyService.notify('socialMediaPlan.failedToLoad'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    applyFilter(filter, query) {
        const f = filter !== null && filter !== void 0 ? filter : this.currentFilter;
        const q = query !== null && query !== void 0 ? query : '';
        let result = [...this.posts];
        if (f !== 'all')
            result = result.filter(p => p.status === f);
        if (q) {
            const lower = q.toLowerCase();
            result = result.filter(p => { var _a; return p.title.toLowerCase().includes(lower) || (((_a = p.brief) === null || _a === void 0 ? void 0 : _a.topic) || '').toLowerCase().includes(lower); });
        }
        this.filteredPosts = result;
    }
    computeStats() {
        this.statScheduled = this.posts.filter(p => p.status === 'scheduled').length;
        this.statDrafts = this.posts.filter(p => p.status === 'draft' || p.status === 'needs_review').length;
        this.statPublished = this.posts.filter(p => p.status === 'published').length;
    }
    switchPage(page) { this.currentPage = page; }
    switchView(view) {
        this.currentView = view;
        if (view === 'harmonogram')
            setTimeout(() => this.initCalendar(), 50);
    }
    initCalendar() {
        const el = this.$('#fcCalendar');
        if (!el)
            return;
        if (this.calendar) {
            this.calendar.refetchEvents();
            return;
        }
        this.calendar = new core_1.Calendar(el, {
            plugins: [daygrid_1.default, interaction_1.default],
            initialView: 'dayGridMonth',
            locale: 'pl',
            height: 'auto',
            events: this.posts.filter(p => p.scheduledAt).map(p => ({
                id: String(p.id), title: p.title, start: p.scheduledAt,
                backgroundColor: _shared_1.STATUS_COLORS[p.status] || '#9199A8',
                borderColor: _shared_1.STATUS_COLORS[p.status] || '#9199A8',
            })),
            eventClick: (info) => {
                const post = this.posts.find(p => String(p.id) === info.event.id);
                if (post) {
                    this.selectedPost = post;
                    this.drawerOpen = true;
                }
            },
        });
        this.calendar.render();
    }
    onFilterChange(e) {
        this.currentFilter = e.detail.filter;
        this.applyFilter(e.detail.filter);
    }
    onSearch(e) {
        this.applyFilter(this.currentFilter, e.detail.query);
    }
    onOpenCreator(e) {
        var _a;
        this.editingPost = ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.post) || null;
        this.creatorOpen = true;
    }
    onNewPost() {
        this.editingPost = null;
        this.creatorOpen = true;
    }
    onOpenDrawer(e) {
        this.selectedPost = e.detail.post;
        this.drawerOpen = true;
    }
    onCloseDrawer() {
        this.drawerOpen = false;
        this.selectedPost = null;
    }
    onCloseCreator() {
        this.creatorOpen = false;
        this.editingPost = null;
    }
    async onPostSaved() {
        this.creatorOpen = false;
        this.editingPost = null;
        this.logActivity('Post zapisany.');
        await this.loadPosts();
    }
    async onEditPost(e) {
        this.onCloseDrawer();
        this.editingPost = e.detail.post;
        this.creatorOpen = true;
    }
    async onDeletePost(e) {
        var _a;
        const post = e.detail.post;
        if (!await this.popupService.confirm('socialMediaPlan.post.deleteConfirm'.t()))
            return;
        const resp = this.proxy
            ? await this.routeSearchService.callGatedBackend('social-media-post.delete', { id: String(post.id) }, undefined, 'DELETE')
            : await this.apiService.back.delete('social-media-post.delete', { routeParams: { id: String(post.id) } });
        if (resp === null || resp === void 0 ? void 0 : resp.success) {
            if (((_a = this.selectedPost) === null || _a === void 0 ? void 0 : _a.id) === post.id)
                this.onCloseDrawer();
            this.logActivity('Usuni\u0119to \u201e' + post.title + '\u201c.');
            await this.loadPosts();
        }
    }
    async onDuplicatePost(e) {
        const post = e.detail.post;
        const resp = this.proxy
            ? await this.routeSearchService.callGatedBackend('social-media-post.duplicate', { id: String(post.id) }, {})
            : await this.apiService.back.post('social-media-post.duplicate', {}, { routeParams: { id: String(post.id) } });
        if (resp === null || resp === void 0 ? void 0 : resp.success) {
            this.logActivity('Zduplikowano \u201e' + post.title + '\u201c.');
            await this.loadPosts();
        }
    }
    async onPublishPost(e) {
        var _a;
        const results = ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.results) || [];
        const succeeded = results.filter(r => r.success);
        const failed = results.filter(r => !r.success);
        if (succeeded.length) {
            const urls = succeeded.map(r => r.postUrl).filter(Boolean).join(' ');
            this.logActivity(`[SUCCESS] Opublikowano na: ${succeeded.map(r => r.platform).join(', ')}${urls ? ' → ' + urls : ''}`);
            await this.loadPosts();
        }
        if (failed.length) {
            failed.forEach(r => this.logActivity(`[ERROR] Błąd publikacji na ${r.platform}: ${r.error || 'nieznany błąd'}`));
        }
    }
    pfBadgesHtml(platforms, size = 26) { return (0, _shared_1.pfBadgesRow)(platforms, size); }
    formatDate(d) { return (0, _shared_1.formatDate)(d); }
    onPreviewApprovalPost(post) {
        this.selectedPost = post;
        this.drawerOpen = true;
    }
    async approvePost(post) {
        const payload = { title: post.title, status: 'scheduled', platforms: post.platforms, brief: post.brief, content: post.content, scheduledAt: post.scheduledAt };
        const resp = this.proxy
            ? await this.routeSearchService.callGatedBackend('social-media-post.update', { id: String(post.id) }, payload, 'PUT')
            : await this.apiService.back.put('social-media-post.update', payload, { routeParams: { id: String(post.id) } });
        if (resp === null || resp === void 0 ? void 0 : resp.success) {
            this.notifyService.notify('socialMediaPlan.approvalQueue.approved'.t(), 'info');
            this.logActivity(`Zatwierdzono „${post.title}".`);
            await this.loadPosts();
        }
        else {
            this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.post.saveFailed'.t(), 'error');
        }
    }
    async rejectPost(post) {
        if (!await this.popupService.confirm('socialMediaPlan.approvalQueue.rejectConfirm'.t()))
            return;
        const payload = { title: post.title, status: 'draft', platforms: post.platforms, brief: post.brief, content: post.content, scheduledAt: post.scheduledAt };
        const resp = this.proxy
            ? await this.routeSearchService.callGatedBackend('social-media-post.update', { id: String(post.id) }, payload, 'PUT')
            : await this.apiService.back.put('social-media-post.update', payload, { routeParams: { id: String(post.id) } });
        if (resp === null || resp === void 0 ? void 0 : resp.success) {
            this.notifyService.notify('socialMediaPlan.approvalQueue.rejected'.t(), 'info');
            this.logActivity(`Odrzucono „${post.title}" → szkic.`);
            await this.loadPosts();
        }
        else {
            this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.post.saveFailed'.t(), 'error');
        }
    }
    logActivity(msg) {
        const now = new Date();
        const ts = String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
        this.activityLog = ['[' + ts + '] ' + msg, ...this.activityLog].slice(0, 50);
    }
};
exports.SocialMediaPlanPage = SocialMediaPlanPage;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaPlanPage.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaPlanPage.prototype, "currentView", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaPlanPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SocialMediaPlanPage.prototype, "posts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SocialMediaPlanPage.prototype, "filteredPosts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SocialMediaPlanPage.prototype, "currentFilter", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof _shared_1.IFrontPost !== "undefined" && _shared_1.IFrontPost) === "function" ? _d : Object)
], SocialMediaPlanPage.prototype, "selectedPost", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaPlanPage.prototype, "drawerOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SocialMediaPlanPage.prototype, "creatorOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof _shared_1.IFrontPost !== "undefined" && _shared_1.IFrontPost) === "function" ? _e : Object)
], SocialMediaPlanPage.prototype, "editingPost", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SocialMediaPlanPage.prototype, "statScheduled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SocialMediaPlanPage.prototype, "statDrafts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SocialMediaPlanPage.prototype, "statPublished", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SocialMediaPlanPage.prototype, "activityLog", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SocialMediaPlanPage.prototype, "postsNeedingReview", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof Map !== "undefined" && Map) === "function" ? _f : Object)
], SocialMediaPlanPage.prototype, "uploadProgress", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SocialMediaPlanPage.prototype, "proxy", void 0);
exports.SocialMediaPlanPage = SocialMediaPlanPage = __decorate([
    (0, client_1.RWSView)('social-media-plan-page', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __param(2, (0, client_1.RWSInject)(_routeSearch_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object, typeof (_c = typeof _routeSearch_1.RouteSearchServiceInstance !== "undefined" && _routeSearch_1.RouteSearchServiceInstance) === "function" ? _c : Object])
], SocialMediaPlanPage);
SocialMediaPlanPage.defineComponent();
